export default function toDateMedium(Authentication, dateFilter) {
  'ngInject';

  const suffixes = ['th', 'st', 'nd', 'rd'];

  return function link(date) {
    if (Authentication.user.settings.usTimeFormat) {
      const monthDay = dateFilter(date, 'MMMM d');
      const day = Number(monthDay.match(/\d+/)[0]);
      const relevantDigits = day < 30 ? day % 20 : day % 30;
      const suffix = relevantDigits <= 3 ? suffixes[relevantDigits] : suffixes[0];
      return `${monthDay}${suffix}, ${dateFilter(date, 'yyyy')}`;
    }

    return dateFilter(date, 'd MMMM yyyy');
  };
}
